import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './MoreInfo.css';
import MyButton from 'components/MyButton/MyButton';
import Strings from 'localization/Strings';

class MoreInfo extends Component {
    constructor(props){
        super(props);
        this.onClickUS = this.onClickUS.bind(this);
        this.onClickAustralia = this.onClickAustralia.bind(this);
    }
    onClickAustralia(){
        let url = 'https://www.cochlear.com/au/en/connect/find-a-clinic'
        window.open(url, '_blank', 'noopener,noreferrer');
    }
    onClickUS(){
        let url = 'https://www.cochlear.com/us/en/connect/find-a-clinic'
        window.open(url, '_blank', 'noopener,noreferrer');
    }
    onClickUK(){
        let url = 'https://www.cochlear.com/uk/en/connect/find-a-clinic'
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    render () {
        return (
            <div className="component-card-content pb250">
                <h5 className="more-info-desc">{Strings.strings.MoreInfo.Description}</h5>
                <h1 className="more-info-title">{Strings.strings.MoreInfo.Title}</h1>
                <Container className='mt-5'>
                    <Row className='d-flex text-center'>
                        <Col >
                            <MyButton className="w100p" type="white" onClick={this.onClickUS}> US </MyButton>
                        </Col>
                        <Col>
                            <MyButton className="w100p" type="white" onClick={this.onClickUK}> UK </MyButton>
                        </Col>
                    </Row>
                </Container> 
            </div>
        );
    }
}

export default MoreInfo;